import {PriorDealsFilterSortingState} from "../../pro-report/prior-deals/filter-model/prior-deals-filter-sorting-state";
import {ContDiscFilterSortingState} from "../../pro-report/prior-deals/filter-model/cont-disc-filter-sorting-state";
import {SortingState} from "../../pro-report/prior-deals/filter-model/sorting-state";

export class FilterState {
  priorDealsFilterSaved: PriorDealsFilterSortingState;
  contDiscFilterSaved: ContDiscFilterSortingState;
  materialEventsFilterSaved: SortingState;
}
